import React from 'react'
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from '../../assets/bgLogo.svg'
import './header.css'
import { defaultPageHeader } from '../../Markup'
import EmailForm from '../EmailForm/emailForm.js'
const Header = ({ headerData, location }) => {
  const pageHeadData = headerData.pageHeadData && headerData.pageHeadData[location] ? headerData.pageHeadData[location] : defaultPageHeader
  return (
    <div className={"app-header " + pageHeadData.class}>
      <Navbar navItems={headerData.navBar} />
      <PageHeader pageHeadData={pageHeadData.data} />
    </div>
  )
}

const PageHeader = ({ pageHeadData }) => {
  return (
    <div className="page-header">
      {pageHeadData.title && <h1 className={(pageHeadData.title.class || "")}>{pageHeadData.title.text}</h1>}
      {pageHeadData.cta && <div className={pageHeadData.cta.class}>
        <p>{pageHeadData.cta.text}</p>
      </div>
      }
      {pageHeadData.emailForm && <EmailForm inputInfo={pageHeadData.emailForm} />}
    </div>
  )
}

const Navbar = ({ navItems }) => {
  let NavItem = ({ item }) => {
    let linkClasses = "MankSans-Medium purple-white " + item.specialClass
    return (<div className={"header-item"}>
      {item.external ? <a className={linkClasses} target={"_blank"} rel="noopener noreferrer" href={item.path}>{item.name}</a> : <Link className={linkClasses} to={item.path}>{item.name}</Link>}
    </div>)
  }
  return (
    <div className="app-navbar">
      <div className={"header-logo"}>
        <Link to="/">
          <Logo fill={"#dfdfff"} alt={"Dark Logo"}/>
        </Link>
      </div>
      <div className={"header-items"}>
        {navItems.map(item =>
          <NavItem key={item.name + "-> " + item.path} item={item} />
        )}
      </div>
    </div>
  )
}

export default Header
